<template>
  <div style="overflow-y: auto;" class="mt-2">
    <balance-section style="margin-top: 0px !important"/>
    <payment-methods-section v-if="isCurrent" />
    <valid-membership-section v-if="isCurrent" />
    <expired-membership-section v-else />
  </div>
</template>

<script>
import BalanceSection from './sections/BalanceSection'
import ExpiredMembershipSection from './sections/ExpiredMembership'
import PaymentMethodsSection from './sections/PaymentMethods'
import ValidMembershipSection from './sections/ValidMembership'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BillingAccountTab',

  components: { 
    BalanceSection,
    ExpiredMembershipSection,
    PaymentMethodsSection,
    ValidMembershipSection
  },

  computed: {
    ...mapGetters('auth', ['me']),

    isCurrent() {
      if (!this.me.membership_last_valid_time) {
        return true
      }

      const now = new Date()
      return now < new Date(this.me.membership_last_valid_time)
    }
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  }
}
</script>
